var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLikeOffLarge = function SvgIconLikeOffLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22s10.5-5.377 10.5-13.085C22.5 5.846 19.987 3 16.888 3c-1.48 0-2.877.578-3.91 1.572-.38.366-.71.789-.978 1.26a5.556 5.556 0 0 0-.979-1.26A5.637 5.637 0 0 0 7.112 3C4.012 3 1.5 5.846 1.5 8.915 1.5 16.623 12 22 12 22ZM7.112 4.5C4.946 4.5 3 6.566 3 8.915c0 3.179 2.195 6.068 4.74 8.306A27.88 27.88 0 0 0 12 20.283a27.877 27.877 0 0 0 4.26-3.062C18.805 14.983 21 12.094 21 8.915 21 6.566 19.054 4.5 16.888 4.5m0 0c-1.492 0-2.86.797-3.583 2.072L12 8.872l-1.305-2.3A4.117 4.117 0 0 0 7.112 4.5",
    fill: "#242526"
  })));
};
export default SvgIconLikeOffLarge;